import { render } from "./Repriceapproval.vue?vue&type=template&id=3e50aeb7&scoped=true"
import script from "./Repriceapproval.vue?vue&type=script&lang=js"
export * from "./Repriceapproval.vue?vue&type=script&lang=js"

import "./Repriceapproval.vue?vue&type=style&index=0&id=3e50aeb7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e50aeb7"]])

export default __exports__